export type DynamicsChartId = 'A' | 'B' | 'C' | 'D' | 'E' | 'G' | 'H' | 'I' | 'J' | 'K';

export interface DynamicsPrefs {
  enabled: DynamicsChartId[];
  groupBy: 'sprint' | 'release' | 'week' | 'month';
  lastN: number;
  /** When true, cards whose batch entry reports no data are hidden from the grid. */
  hideEmpty: boolean;
}

const KEY = 'analytics.quality.dynamicsPrefs.v1';
const DEFAULT_ENABLED: DynamicsChartId[] = ['A', 'C', 'E'];

export function loadDynamicsPrefs(): DynamicsPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultPrefs();
    const parsed = JSON.parse(raw);
    return {
      enabled: Array.isArray(parsed?.enabled)
        ? (parsed.enabled.filter(
            (x: unknown): x is DynamicsChartId => typeof x === 'string' && 'ABCDEGHIJK'.includes(x)
          ) as DynamicsChartId[])
        : DEFAULT_ENABLED,
      groupBy:
        parsed?.groupBy === 'release' ||
        parsed?.groupBy === 'week' ||
        parsed?.groupBy === 'month' ||
        parsed?.groupBy === 'sprint'
          ? parsed.groupBy
          : 'sprint',
      lastN: typeof parsed?.lastN === 'number' && parsed.lastN > 0 ? Math.min(parsed.lastN, 52) : 8,
      hideEmpty: typeof parsed?.hideEmpty === 'boolean' ? parsed.hideEmpty : false,
    };
  } catch {
    return defaultPrefs();
  }
}

export function saveDynamicsPrefs(p: DynamicsPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // ignore quota
  }
}

export function defaultPrefs(): DynamicsPrefs {
  return { enabled: DEFAULT_ENABLED, groupBy: 'sprint', lastN: 8, hideEmpty: false };
}
